import type { ActionDp, Logger, LogOptions } from 'telemetry';
import { setLogger } from 'telemetry';
import { logUsage, PerformanceDatapoint } from 'owa-analytics';
import type { DatapointOptions } from 'owa-analytics-types';

/** Initialize logger with logUsage and PerformanceDatapoint from owa-analytics */
export function initializeLogger() {
    setLogger(MiniAppLogger);
}

const MiniAppLogger: Logger = {
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type. */
    logData: (eventName: string, logData?: any, logOptions?: LogOptions) =>
        logUsage(eventName, logData, logOptions as DatapointOptions),

    getActionDp: (eventName: string, options?: LogOptions): ActionDp =>
        new PerformanceDatapoint(eventName, options as DatapointOptions),
};
